module.exports = __webpack_public_path__ + "img/doctor-fallback.bf576e0b.png";